import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "xwide8": "main-logged-out-58e5f421-xwide8-WXUgJq",
  "defaultOffset1": "main-logged-out-58e5f421-defaultOffset1-WXUgJq",
  "confined9": "main-logged-out-58e5f421-confined9-WXUgJq",
  "xwide0": "main-logged-out-58e5f421-xwide0-WXUgJq",
  "tinyOffset1": "main-logged-out-58e5f421-tinyOffset1-WXUgJq",
  "defaultOffset3": "main-logged-out-58e5f421-defaultOffset3-WXUgJq",
  "tiny1": "main-logged-out-58e5f421-tiny1-WXUgJq",
  "tiny6": "main-logged-out-58e5f421-tiny6-WXUgJq",
  "xwideOffset9": "main-logged-out-58e5f421-xwideOffset9-WXUgJq",
  "wide1": "main-logged-out-58e5f421-wide1-WXUgJq",
  "wideOffset5": "main-logged-out-58e5f421-wideOffset5-WXUgJq",
  "default3": "main-logged-out-58e5f421-default3-WXUgJq",
  "confinedOffset4": "main-logged-out-58e5f421-confinedOffset4-WXUgJq",
  "confinedOffset8": "main-logged-out-58e5f421-confinedOffset8-WXUgJq",
  "tinyOffset2": "main-logged-out-58e5f421-tinyOffset2-WXUgJq",
  "wide4": "main-logged-out-58e5f421-wide4-WXUgJq",
  "tiny2": "main-logged-out-58e5f421-tiny2-WXUgJq",
  "xwide12": "main-logged-out-58e5f421-xwide12-WXUgJq",
  "confined8": "main-logged-out-58e5f421-confined8-WXUgJq",
  "confinedOffset5": "main-logged-out-58e5f421-confinedOffset5-WXUgJq",
  "default4": "main-logged-out-58e5f421-default4-WXUgJq",
  "default12": "main-logged-out-58e5f421-default12-WXUgJq",
  "confined0": "main-logged-out-58e5f421-confined0-WXUgJq",
  "confined5": "main-logged-out-58e5f421-confined5-WXUgJq",
  "defaultOffset5": "main-logged-out-58e5f421-defaultOffset5-WXUgJq",
  "xwideOffset1": "main-logged-out-58e5f421-xwideOffset1-WXUgJq",
  "confinedOffset7": "main-logged-out-58e5f421-confinedOffset7-WXUgJq",
  "xwideOffset4": "main-logged-out-58e5f421-xwideOffset4-WXUgJq",
  "default2": "main-logged-out-58e5f421-default2-WXUgJq",
  "confined11": "main-logged-out-58e5f421-confined11-WXUgJq",
  "tiny10": "main-logged-out-58e5f421-tiny10-WXUgJq",
  "armstrongGridContainer": "main-logged-out-58e5f421-armstrongGridContainer-WXUgJq",
  "wide8": "main-logged-out-58e5f421-wide8-WXUgJq",
  "xwide5": "main-logged-out-58e5f421-xwide5-WXUgJq",
  "default1": "main-logged-out-58e5f421-default1-WXUgJq",
  "default9": "main-logged-out-58e5f421-default9-WXUgJq",
  "wide6": "main-logged-out-58e5f421-wide6-WXUgJq",
  "default8": "main-logged-out-58e5f421-default8-WXUgJq",
  "wide9": "main-logged-out-58e5f421-wide9-WXUgJq",
  "xwideOffset5": "main-logged-out-58e5f421-xwideOffset5-WXUgJq",
  "tinyOffset11": "main-logged-out-58e5f421-tinyOffset11-WXUgJq",
  "default7": "main-logged-out-58e5f421-default7-WXUgJq",
  "confinedOffset1": "main-logged-out-58e5f421-confinedOffset1-WXUgJq",
  "tinyOffset5": "main-logged-out-58e5f421-tinyOffset5-WXUgJq",
  "defaultOffset7": "main-logged-out-58e5f421-defaultOffset7-WXUgJq",
  "wide11": "main-logged-out-58e5f421-wide11-WXUgJq",
  "xwideOffset11": "main-logged-out-58e5f421-xwideOffset11-WXUgJq",
  "tinyOffset3": "main-logged-out-58e5f421-tinyOffset3-WXUgJq",
  "tinyOffset4": "main-logged-out-58e5f421-tinyOffset4-WXUgJq",
  "tiny12": "main-logged-out-58e5f421-tiny12-WXUgJq",
  "confined7": "main-logged-out-58e5f421-confined7-WXUgJq",
  "confinedOffset2": "main-logged-out-58e5f421-confinedOffset2-WXUgJq",
  "tiny9": "main-logged-out-58e5f421-tiny9-WXUgJq",
  "confinedOffset6": "main-logged-out-58e5f421-confinedOffset6-WXUgJq",
  "wide3": "main-logged-out-58e5f421-wide3-WXUgJq",
  "wide0": "main-logged-out-58e5f421-wide0-WXUgJq",
  "tiny5": "main-logged-out-58e5f421-tiny5-WXUgJq",
  "wideOffset8": "main-logged-out-58e5f421-wideOffset8-WXUgJq",
  "default11": "main-logged-out-58e5f421-default11-WXUgJq",
  "default10": "main-logged-out-58e5f421-default10-WXUgJq",
  "xwide6": "main-logged-out-58e5f421-xwide6-WXUgJq",
  "tiny4": "main-logged-out-58e5f421-tiny4-WXUgJq",
  "confinedOffset9": "main-logged-out-58e5f421-confinedOffset9-WXUgJq",
  "wide2": "main-logged-out-58e5f421-wide2-WXUgJq",
  "wideGridContainer": "main-logged-out-58e5f421-wideGridContainer-WXUgJq",
  "wideOffset1": "main-logged-out-58e5f421-wideOffset1-WXUgJq",
  "default0": "main-logged-out-58e5f421-default0-WXUgJq",
  "xwideOffset2": "main-logged-out-58e5f421-xwideOffset2-WXUgJq",
  "col": "main-logged-out-58e5f421-col-WXUgJq",
  "tinyOffset8": "main-logged-out-58e5f421-tinyOffset8-WXUgJq",
  "xwideOffset0": "main-logged-out-58e5f421-xwideOffset0-WXUgJq",
  "default6": "main-logged-out-58e5f421-default6-WXUgJq",
  "standardGridContainer": "main-logged-out-58e5f421-standardGridContainer-WXUgJq",
  "confined12": "main-logged-out-58e5f421-confined12-WXUgJq",
  "xwideOffset8": "main-logged-out-58e5f421-xwideOffset8-WXUgJq",
  "wide10": "main-logged-out-58e5f421-wide10-WXUgJq",
  "confined1": "main-logged-out-58e5f421-confined1-WXUgJq",
  "xwide11": "main-logged-out-58e5f421-xwide11-WXUgJq",
  "confined6": "main-logged-out-58e5f421-confined6-WXUgJq",
  "xwide10": "main-logged-out-58e5f421-xwide10-WXUgJq",
  "xwide2": "main-logged-out-58e5f421-xwide2-WXUgJq",
  "tiny7": "main-logged-out-58e5f421-tiny7-WXUgJq",
  "tinyOffset9": "main-logged-out-58e5f421-tinyOffset9-WXUgJq",
  "wide5": "main-logged-out-58e5f421-wide5-WXUgJq",
  "wideOffset3": "main-logged-out-58e5f421-wideOffset3-WXUgJq",
  "tinyOffset10": "main-logged-out-58e5f421-tinyOffset10-WXUgJq",
  "wideOffset11": "main-logged-out-58e5f421-wideOffset11-WXUgJq",
  "row": "main-logged-out-58e5f421-row-WXUgJq",
  "xwide4": "main-logged-out-58e5f421-xwide4-WXUgJq",
  "confined3": "main-logged-out-58e5f421-confined3-WXUgJq",
  "xwideOffset10": "main-logged-out-58e5f421-xwideOffset10-WXUgJq",
  "tinyOffset7": "main-logged-out-58e5f421-tinyOffset7-WXUgJq",
  "confined10": "main-logged-out-58e5f421-confined10-WXUgJq",
  "wideOffset4": "main-logged-out-58e5f421-wideOffset4-WXUgJq",
  "wideOffset9": "main-logged-out-58e5f421-wideOffset9-WXUgJq",
  "wideOffset10": "main-logged-out-58e5f421-wideOffset10-WXUgJq",
  "wideOffset7": "main-logged-out-58e5f421-wideOffset7-WXUgJq",
  "tiny3": "main-logged-out-58e5f421-tiny3-WXUgJq",
  "defaultOffset2": "main-logged-out-58e5f421-defaultOffset2-WXUgJq",
  "default5": "main-logged-out-58e5f421-default5-WXUgJq",
  "tiny8": "main-logged-out-58e5f421-tiny8-WXUgJq",
  "tiny11": "main-logged-out-58e5f421-tiny11-WXUgJq",
  "xwideOffset7": "main-logged-out-58e5f421-xwideOffset7-WXUgJq",
  "xwide3": "main-logged-out-58e5f421-xwide3-WXUgJq",
  "defaultOffset11": "main-logged-out-58e5f421-defaultOffset11-WXUgJq",
  "tinyOffset6": "main-logged-out-58e5f421-tinyOffset6-WXUgJq",
  "confined4": "main-logged-out-58e5f421-confined4-WXUgJq",
  "confinedOffset3": "main-logged-out-58e5f421-confinedOffset3-WXUgJq",
  "defaultOffset4": "main-logged-out-58e5f421-defaultOffset4-WXUgJq",
  "defaultOffset8": "main-logged-out-58e5f421-defaultOffset8-WXUgJq",
  "defaultOffset10": "main-logged-out-58e5f421-defaultOffset10-WXUgJq",
  "xwide1": "main-logged-out-58e5f421-xwide1-WXUgJq",
  "xwideOffset3": "main-logged-out-58e5f421-xwideOffset3-WXUgJq",
  "grid": "main-logged-out-58e5f421-grid-WXUgJq",
  "xwide7": "main-logged-out-58e5f421-xwide7-WXUgJq",
  "wideOffset2": "main-logged-out-58e5f421-wideOffset2-WXUgJq",
  "defaultOffset9": "main-logged-out-58e5f421-defaultOffset9-WXUgJq",
  "confinedOffset10": "main-logged-out-58e5f421-confinedOffset10-WXUgJq",
  "wide12": "main-logged-out-58e5f421-wide12-WXUgJq",
  "xwide9": "main-logged-out-58e5f421-xwide9-WXUgJq",
  "xwideOffset6": "main-logged-out-58e5f421-xwideOffset6-WXUgJq",
  "confinedOffset11": "main-logged-out-58e5f421-confinedOffset11-WXUgJq",
  "wideOffset0": "main-logged-out-58e5f421-wideOffset0-WXUgJq",
  "confined2": "main-logged-out-58e5f421-confined2-WXUgJq",
  "defaultOffset6": "main-logged-out-58e5f421-defaultOffset6-WXUgJq",
  "gridContainer": "main-logged-out-58e5f421-gridContainer-WXUgJq",
  "confinedOffset0": "main-logged-out-58e5f421-confinedOffset0-WXUgJq",
  "wide7": "main-logged-out-58e5f421-wide7-WXUgJq",
  "wideOffset6": "main-logged-out-58e5f421-wideOffset6-WXUgJq",
  "tinyOffset0": "main-logged-out-58e5f421-tinyOffset0-WXUgJq",
  "tiny0": "main-logged-out-58e5f421-tiny0-WXUgJq"
};